import { render } from "./SubaruFlexSpaceBanner.vue?vue&type=template&id=3ee7ca45"
import script from "./SubaruFlexSpaceBanner.vue?vue&type=script&lang=js"
export * from "./SubaruFlexSpaceBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__